<script lang="ts">
  import type { Snippet } from 'svelte'

  let {
    variant = 'primary',
    size = 'md',
    disabled = false,
    onclick,
    type = 'button',
    class: className = '',
    children,
    iconOnly = false,
    'data-testid': dataTestId,
  }: {
    variant?: 'primary' | 'secondary' | 'danger' | 'success' | 'ghost'
    size?: 'sm' | 'md' | 'lg'
    disabled?: boolean
    onclick?: (e: MouseEvent) => void
    type?: 'button' | 'submit' | 'reset'
    class?: string
    children: Snippet
    iconOnly?: boolean
    'data-testid'?: string
  } = $props()

  const baseClasses =
    'inline-flex items-center justify-center rounded-full font-medium transition-colors focus:outline-none focus:ring-2 disabled:opacity-50 disabled:cursor-not-allowed'

  const variantClasses = {
    primary:
      'bg-primary-500 text-neutral-50 hover:bg-primary-600 focus:ring-primary-500 shadow-sm',
    secondary:
      'bg-bookshop-lavender text-neutral-700 dark:text-gray-200 hover:brightness-95 focus:ring-primary-400 border border-transparent',
    danger:
      'bg-danger-500 text-neutral-50 hover:bg-danger-600 focus:ring-danger-500 shadow-sm',
    success:
      'bg-success-500 text-neutral-50 hover:bg-success-600 focus:ring-success-500 shadow-sm',
    ghost:
      'bg-transparent hover:bg-neutral-100 text-neutral-500 focus:ring-neutral-400',
  }

  const sizeClasses = $derived({
    sm: iconOnly ? 'p-1.5' : 'px-3 py-1.5 text-sm',
    md: iconOnly ? 'p-2' : 'px-4 py-2 text-base',
    lg: iconOnly ? 'p-3' : 'px-6 py-3 text-lg',
  })
</script>

<button
  {type}
  {onclick}
  {disabled}
  class="{baseClasses} {variantClasses[variant]} {sizeClasses[
    size
  ]} {className}"
  {...dataTestId && { 'data-testid': dataTestId }}
>
  {@render children()}
</button>
